export default __webpack_public_path__ + "static/media/817c46f0490bf236f3c30f7fdd6e5df3.209ef84d.svg";